//**auto-generated don't edit this code**//
import {ContractHttpClient} from '@esgi/contracts';
import {Observable} from 'rxjs';

export function linkingCallback(httpClient: ContractHttpClient) {
	return (code: string): Observable<void> => {
		return httpClient.request<void>(
			'GET',
			'/integrations/class-link/linking/callback',
			code,
		).asObservable();
	};
}
